import { render, staticRenderFns } from "./PresaleStoreLabels.vue?vue&type=template&id=b0beaebe&scoped=true&"
import script from "./PresaleStoreLabels.vue?vue&type=script&lang=js&"
export * from "./PresaleStoreLabels.vue?vue&type=script&lang=js&"
import style0 from "./PresaleStoreLabels.vue?vue&type=style&index=0&id=b0beaebe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0beaebe",
  null
  
)

export default component.exports